import { Identity, UserBank } from './types';
import { Settings } from 'luxon';

const getCatalogLink = ({
  referrerUrl = '',
  bank,
  currentIdentity,
}: {
  referrerUrl?: string;
  bank?: UserBank | null;
  currentIdentity?: Identity | null;
}) => {
  const lang = currentIdentity?.language || Settings.defaultLocale;
  if (!currentIdentity || !bank) return '';

  const queryParams = new URLSearchParams({
    countryCode:
      currentIdentity.profile?.catalogCoreCountry?.iso2Code ||
      currentIdentity.profile?.homeCoreLocation?.country ||
      '',
    programId: bank?.programId?.toString() || '',
    refererUrl: referrerUrl,
    locale: (lang || navigator.languages?.[0] || navigator.language).replace(
      '-',
      '_',
    ),
  });

  return `/catalog?${queryParams}`;
};

export default getCatalogLink;
